import { useContext, useEffect, useState } from 'react';
import * as QuestionnaireApiModels from '@/typings/questionnaires-api-models';
import { getValidationRules } from '@helpers/validation/schema';
import { useQuestionnaireFormContext } from '@/components/Questionnaire/QuestionnaireProvider';
import DashboardContext from '@/layouts/DashboardLayout/DashboardContext';
import classNames from 'classnames';

import { FormFieldProps } from '../../FormField/types';
import s from './EditListItemModal.module.scss';

type ThisField =
  & Pick<QuestionnaireApiModels.FieldTemplate, 'id'>
  & FormFieldProps['listField'];

type SubField =
  & ThisField
  & {
    computedKey: string;
    computedLinkedFields: FormFieldProps['field']['linkedFields'];
    computedListItemTemplates: FormFieldProps['field']['listItemTemplates'];
  };

type Props = {
  currentListSubsection: string | null;
  field: ThisField;
  fieldsAutofilling: string[];
  FormFieldComponent: React.FC<FormFieldProps>;
  linkSourceFieldKey: string;
  listSubsections: string[];
  modalSubFields: SubField[];
  onOpenModalFromReferencedList: FormFieldProps['openModalFromReferencedList'];
  onUpdateReferencedListData: FormFieldProps['handleReferencedListDataUpdate'];
  rowIndex: number;
};

const ModalFormContent: React.FC<Props> = ({
  FormFieldComponent,
  currentListSubsection,
  field,
  fieldsAutofilling,
  onUpdateReferencedListData,
  linkSourceFieldKey,
  listSubsections,
  modalSubFields,
  onOpenModalFromReferencedList,
  rowIndex,
}: Props) => {
  const {
    formMethods,
  } = useQuestionnaireFormContext();

  const { isInDashboard } = useContext(DashboardContext);

  // @TODO - useWatch (or useWatchFields) instead of watch
  const [listResponses, setListResponses] = useState(formMethods.watch(linkSourceFieldKey) || []);
  const watcher = formMethods.watch(linkSourceFieldKey);
  useEffect(() => {
    setListResponses(watcher || []);
  },[watcher]);

  return (
    <div className={classNames(s.modalContent, isInDashboard && s.modalContentDashboard)} {...listSubsections.length === 0 && { style: { minHeight: 'unset' } }}>
      {modalSubFields
        .filter((f) => currentListSubsection ? f.listSubsection === currentListSubsection : true)
        .map(subField => (
          <FormFieldComponent
            key={subField.id}
            index={rowIndex}
            listField={field}
            field={{
              ...subField,
              key: subField.computedKey,
              linkedFields: subField.computedLinkedFields,
              listItemTemplates: subField.computedListItemTemplates,
            }}
            control={formMethods.control}
            rules={getValidationRules(subField)}
            isEditing={listResponses[rowIndex]?._existsInDb}
            fieldsAutofilling={fieldsAutofilling}
            handleReferencedListDataUpdate={onUpdateReferencedListData}
            openModalFromReferencedList={onOpenModalFromReferencedList}
          />
        ))
      }
    </div>
  );
};

export default ModalFormContent;
